import MyTabs from '../../components/MyTabs';
import AdminUser from './AdminUser';

const GeneralAdminUser = () => {
    const tabs = [
        { id: "basic", title: "Basic Info", Component: AdminUser },
    ];

    return (
        <MyTabs list={tabs} />
    );
};

export default GeneralAdminUser;
